import React from 'react';
import { APP_NAME } from '../../config/appConstants';
import PublicInfoLayout from '../../shared/components/layouts/PublicInfoLayout';
import './LegalPages.css';

export default function TermsOfServicePage() {
  const updatedAt = 'May 27, 2026';

  return (
    <PublicInfoLayout>
      <h1>Terms of Service</h1>
      <p className="legal-subtitle">
        {APP_NAME} • Last updated: {updatedAt}
      </p>

      <h2>Use of the application</h2>
      <p>
        By accessing or using {APP_NAME}, you agree to use the application only for authorized, legitimate business
        purposes and in accordance with your organization’s policies.
      </p>

      <h2>Account responsibility</h2>
      <ul>
        <li>Keep your credentials secure and do not share access.</li>
        <li>Use role-based access appropriately and only access data you are permitted to view.</li>
        <li>Report suspected security issues to your administrator promptly.</li>
      </ul>

      <h2>Acceptable use</h2>
      <ul>
        <li>Do not attempt to bypass authentication or authorization controls.</li>
        <li>Do not upload malicious content or interfere with application availability.</li>
        <li>Do not misuse data exports or access outside your permitted scope.</li>
      </ul>

      <h2>Contact</h2>
      <p>
        For questions regarding these terms, contact your system administrator or support team for your organization.
      </p>
    </PublicInfoLayout>
  );
}

